(() => {
  'use strict';
  if (customElements.get('ct-package-picker')) return;
  customElements.define('ct-package-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (!this.querySelector('form')) { this.timer = setTimeout(() => this.connectedCallback(), 0); return; }
      const el = this;
      this.controller = new AbortController();
      const on = (node, event, fn) => node.addEventListener(event, fn, {signal:this.controller.signal});
      const form = el.querySelector('form');
      const add = form.querySelector('[name="add"]');
      const buy = form.querySelector('[data-tp-buy]');
      const status = form.querySelector('.tp-form-status');
      let busy = false;
      const packages = [...el.querySelectorAll('[data-package-item]')].map(node => ({node, radio:node.querySelector('[data-package-radio]'), select:node.querySelector('[data-package-variant]'), data:JSON.parse(node.querySelector('[data-package-json]').textContent)}));
      const active = () => packages.find(p => p.radio.checked);
      const variant = p => p.data.variants.find(v => String(v.id) === (p.select ? p.select.value : p.radio.value));
      const selected = () => {const p = active(); return p && variant(p);};
      const image = (src, alt) => {
        let img = el.querySelector('.tp-gallery__main');
        if (!img && src) { img=document.createElement('img');img.className='tp-gallery__main';img.loading='lazy';el.querySelector('.tp-gallery').prepend(img); }
        if (!img) return;
        img.hidden = !src;
        if (!src) return;
        img.removeAttribute('srcset'); img.removeAttribute('width'); img.removeAttribute('height'); img.src=src; img.alt=alt || '';
        el.querySelectorAll('[data-tp-image]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.tpImage===src)));
      };
      const update = () => {
        packages.forEach(p => {
          const v=variant(p);p.radio.value=String(v.id);
          p.radio.disabled=busy;if(p.select)p.select.disabled=busy;
          const wrap=p.node.querySelector('[data-package-variant-wrap]');if(wrap)wrap.hidden=!p.radio.checked;
          p.node.querySelector('[data-package-price]').innerHTML=v.price;
          const compare=p.node.querySelector('[data-package-compare]');compare.innerHTML=v.compare;compare.hidden=!v.onSale;
          p.node.querySelector('[data-package-stock]').textContent=v.available?'':'Tükendi';
        });
        const p=active(),v=selected();add.disabled=buy.disabled=busy||!v?.available;
        if(!v)return;
        el.querySelector('[data-tp-price]').innerHTML=v.price;
        const compare=el.querySelector('[data-tp-compare]');compare.innerHTML=v.compare;compare.hidden=!v.onSale;
        el.querySelector('[data-tp-total]').innerHTML=v.price;
        el.querySelector('[data-tp-stock]').textContent=v.available?'Siparişe açık':'Tükendi';
      };
      packages.forEach(p => {
const change = () => {
  if (busy) return;
  update();
  status.textContent = '';
};
        on(p.radio,'change',change);
        if(p.select)on(p.select,'change',()=>{p.radio.checked=true;change();});
      });
      el.querySelectorAll('[data-tp-image]').forEach(b=>on(b,'click',()=>image(b.dataset.tpImage,b.dataset.alt)));
        on(form, 'submit', async event => {
          event.preventDefault();
          if (busy || !selected()?.available) return;
          const checkout = event.submitter === buy;
          busy = true; update(); form.setAttribute('aria-busy', 'true');
          status.textContent = 'Ürün sepete ekleniyor…';
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const data = new FormData(form);
          data.delete('checkout'); data.delete('add');
          data.set('id', String(selected().id)); data.set('quantity', '1');
          if (cart?.getSectionsToRender && !checkout) {
            data.set('sections', cart.getSectionsToRender().map(s => s.id).join(','));
            data.set('sections_url', location.pathname);
            cart.setActiveElement?.(event.submitter || add);
          }
          try {
            const response = await fetch(el.dataset.addUrl + (el.dataset.addUrl.endsWith('.js') ? '' : '.js'), {
              method: 'POST', headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:data
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Ürün eklenemedi. Lütfen seçimi ve stok durumunu kontrol edin.');
            status.textContent = 'Ürün sepetinize eklendi.';
            if (checkout) { location.assign(el.dataset.checkoutUrl); return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'tp-home'});
            if (cart?.renderContents && result.sections && Object.values(result.sections).every(Boolean)) {
              try { cart.classList.remove('is-empty'); cart.renderContents(result); }
              catch { location.assign(el.dataset.cartUrl); }
            } else { location.assign(el.dataset.cartUrl); }
          } catch (error) {
            status.textContent = error instanceof TypeError ? 'Bağlantı kesildi. Yeniden denemeden önce sepetinizi kontrol edin.' : error.message;
          } finally { busy = false; form.removeAttribute('aria-busy'); update(); }
        });
      update();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller=null; }
  });
})();
